import { render } from "./pageInformation.vue?vue&type=template&id=15a03643&scoped=true"
import script from "./pageInformation.vue?vue&type=script&lang=js"
export * from "./pageInformation.vue?vue&type=script&lang=js"

import "./pageInformation.vue?vue&type=style&index=0&id=15a03643&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a03643"]])

export default __exports__